module.exports = __webpack_public_path__ + "img/ignisForm.3e4b18c7.svg";